import React from 'react';
import request from '../../../request';
import { Link } from 'react-router-dom';

export default class EditStudy extends React.Component {
  constructor({ study }) {
    super();
    this.state = {
      loading: true,
      patient_name: study.patient_name,
      scored_by_user_id: study.scored_by ? study.scored_by.id : '',
      assignees: JSON.parse(
        localStorage.getItem(`assignees-${study.id}`) || '[]'
      ),
    };
  }

  async componentDidMount() {
    let { study } = this.props;
    let type = localStorage.getItem('type');
    if (type !== 'admin' && type !== 'company admin') return;
    try {
      let assignees = await request({ url: `studies/${study.id}/assignees` });
      localStorage.setItem(`assignees-${study.id}`, JSON.stringify(assignees));

      this.setState({ assignees, loading: false });
    } catch (error) {
      this.setState({ error: error.message, loading: false });
    }
  }

  async save() {
    let { study, setStudy } = this.props;
    let { scored_by_user_id, patient_name } = this.state;
    this.setState({ loading: true });

    try {
      let response = await request({
        url: `studies/${study.id}`,
        method: 'PATCH',
        body: {
          scored_by_user_id,
          patient_name,
        },
      });
      setStudy(response);
    } catch (error) {
      this.setState({ error: error.message, loading: false });
    }
  }

  render() {
    let { match, claim, study } = this.props;
    let {
      patient_name,
      scored_by_user_id,
      assignees,
      error,
      loading,
    } = this.state;
    let type = localStorage.getItem('type');

    return (
      <div id="edit" className="edge" style={{ opacity: loading ? 0.5 : 1 }}>
        <h5 className="heading">Edit study</h5>
        <div id="dashboard">
          {error ? <p className="error">{error}</p> : null}
          <div className="field">
            <label htmlFor="patient_name">Patient Name</label>
            <input
              id="patient_name"
              type="text"
              value={patient_name}
              className="on"
              onChange={e => this.setState({ patient_name: e.target.value })}
            />
          </div>

          {study.status !== 'scored' &&
            (type === 'admin' || type === 'company admin')
            ? <div className="field">
                <label htmlFor="state">Assignee</label>
                <select
                  id="scorer_user_id"
                  value={scored_by_user_id}
                  onChange={e =>
                    this.setState({ scored_by_user_id: e.target.value })}
                >
                  {scored_by_user_id
                    ? null
                    : <option value="">Please select</option>}
                  {assignees.map(assignee => (
                    <option key={assignee.id} value={assignee.id}>
                      {assignee.display_name}
                    </option>
                  ))}
                </select>

                {study.status === 'progress'
                  ? <div className="action" onClick={() => claim(false)}>
                      Return study to pending queue
                    </div>
                  : null}
              </div>
            : null}
          <div className="options">
            <button
              id="save"
              className="action primary"
              type="submit"
              onClick={() => this.save()}
            >
              Save
            </button>
            <Link className="action" to={`/study/${match.params.id}`}>
              Cancel
            </Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/components/edit-study.js